import { Component, OnInit } from '@angular/core';
import { SallerBuyerService } from '../../sallerBuyer.service';
import { AuthService } from 'src/app/auth/services/auth.service';
import { UserService } from 'src/app/views/users/services/user.service';

@Component({
  selector: 'app-highlighter',
  templateUrl: './highlighter.component.html',
  styleUrls: ['./highlighter.component.scss']
})
export class HighlighterComponent implements OnInit {
  currentUser: any;
  userDetails: any;

  constructor(
    private userService: UserService,
    private authService: AuthService
  ) { }

  ngOnInit(): void {
    this.currentUser = this.authService.currentUserValue;
    this.getUser();
  }

  getUser(){
    this.userService.getUserInfo({}).subscribe((res: any) => {
      this.userDetails = res.result[0];
    });
  }

}
